export default {
  女装: "የሴቶች አልባሳት",
  男装: "የወንዶች",
  手机和小工具: "የሞባይል ስልክ እና ትናንሽ መሣሪያዎች",
  居家生活: "የቤት ሕይወት",
  电脑及周边设备: "የኮምፒተር እና የርቀት መሳሪያ",
  美容及个人护理: "ውበት እና የግል እንክብካቤ",
  家用电器: "መገልገያ",
  健康与保健: "የጤና እና የጤና እንክብካቤ",
  食品和饮料: "ምግብ እና መጠጥ",
  玩具_儿童和婴儿: "አሻንጉሊቶች, ልጆች እና ሕፃናት",
  童装时尚: "የልጆች ልብስ ፋሽን",
  视频游戏: "ምስለ-ልግፃት",
  运动与户外: "የአካል ብቃት እንቅስቃሴ እና ከቤት ውጭ",
  爱好与书籍: "የትርፍ ጊዜ ማሳለፊያዎች እና መጻሕፍት",
  相机和无人机: "ካሜራ እና ደንብ",
  宠物食品及用品: "የቤት እንስሳት ምግብ እና አቅርቦቶች",
  女士包袋: "የሴቶች ቦርሳ",
  男士包袋: "የወንዶች ቦርሳ",
  珠宝及配饰: "ጌጣጌጦች እና መለዋወጫዎች",
  手表: "ይመልከቱ",
  女鞋: "የሴቶች ጫማዎች",
  男装鞋: "የወንዶች ጫማዎች",
  汽车: "መኪና",
  我附近的ShopeePay: "በአቅራቢያዬ አጠገብ",
  餐饮_旅行和服务: "ምግብ, ጉዞ እና አገልግሎት",
  旅行及行李: "ጉዞ እና ሻንጣዎች",
  各种各样的: "የተለያዩ",
  我是来买什么的: "እኔ ለመግዛት እዚህ ነኝ",
  对不起_找不到_相关的商品: "ይቅርታ, [{0}] ተዛማጅ ምርቶች ማግኘት አይችሉም",
  类别: "ምድብ",
  产品: "ምርት",
  店铺: "ሱቅ",
  首页: "የፊት ገጽ",
  限时秒杀: "የተገደበ የጊዜ ሰልፍ",
  博客: "ብሎግ",
  所有品牌: "ሁሉም የምርት ስሞች",
  所有类别: "ሁሉም ምድቦች",
  我的购物车: "የእኔ ግ shopping ጋሪ",
  发货信息: "የመላኪያ መረጃ",
  交货信息: "የመላኪያ መረጃ",
  付款: "ክፍያ",
  确认: "አረጋግጥ",
  您的购物车是空的: "የግ shopping ጋሪዎ ባዶ ነው",
  价格: "ዋጋ",
  税: "ግብር",
  数量: "ብዛት",
  总计: "ጠቅላላ",
  移除: "ያስወግዱ",
  返回商店: "ወደ ሱቁ ይመለሱ",
  继续发货: "ማቅረቢያ ቀጥል",
  筛选: "ማጣሪያ",
  价格范围: "ዋጋ",
  排序方式: "ደርድር በ",
  最新: "እስከዛሬ ድረስ",
  最旧: "አሮጌ",
  价格从低到高: "ከዝቅተኛ ወደ ከፍተኛ ዋጋ",
  价格从高到低: "ከከፍተኛ እስከ ዝቅተኛ ዋጋ ያለው ዋጋ",
  选择交货类型: "የመላኪያ አይነት ይምረጡ",
  送货上门: "ማድረስ",
  继续付款: "መክፈልዎን ይቀጥሉ",
  任何其他信息: "ሌላ ማንኛውም መረጃ",
  或者: "ወይም",
  您的钱包余额: "የኪስ ቦርሳዎ ቀሪ ሂሳብ",
  余额不足: "በቂ ያልሆነ ሚዛን",
  支付: "ይክፈሉ",
  我同意: "እሳማማ አለህው",
  条款和条件: "ውሎች እና ሁኔታዎች",
  退货政策: "የመመለስ ፖሊሲ",
  隐私政策: "ግላዊነት",
  概括: "ድምር",
  项目: "ፕሮጀክት",
  全部的: "ሁሉም",
  小计: "ንድፍ",
  总运费: "ጠቅላላ ጭነት",
  有优惠码吗_在这里输入: "የቅናሽ ኮድ አለ? እዚህ ግባ",
  申请: "ይተግብሩ",
  编辑: "አርትዕ",
  删除: "ሰርዝ",
  添加新地址: "አዲስ አድራሻ ያክሉ",
  继续交货信息: "የመላኪያ መረጃዎን ይቀጥሉ",
  选择一个地址: "አድራሻ ይምረጡ",
  购买历史: "ታሪክ ይግዙ",
  下载: "ማውረድ",
  已发送退款请求: "ተመላሽ ገንዘብ ተመላሽ ገንዘብ ተመላሽ ገንዘብ ጥያቄን ይልካል",
  对比: "ንፅፅር",
  对话: "ውይይት",
  我的钱包: "የእኔ ኪስ ቦርሳዬ",
  工单: "የሥራ ትዕዛዝ",
  管理个人资料: "የግል መረጃን ያቀናብሩ",
  登出: "ዘግቷል",
  重置对比列表: "ንፅፅር ዝርዝር ዳግም ያስጀምሩ",
  您的对比列表为空: "የንፅፅር ዝርዝርዎ ባዶ ነው",
  在您的购物车中: "ግ shopping ጋሪዎ ውስጥ",
  在您的愿望清单中: "በፈለጉት ዝርዝር ውስጥ",
  在您的预定列表中: "በተያዘው ዝርዝርዎ ውስጥ",
  下载您的产品: "ምርትዎን ያውርዱ",
  选项: "አማራጭ",
  什么都没找到: "ምንም አላገኘሁም",
  特色产品: "ልዩ ምርት",
  最畅销: "በጣም ጥሩ",
  前_名: "ቀዳሚ {0} ስም",
  查看更多: "ተጨማሪ ይመልከቱ",
  查看所有类别: "ሁሉንም ምድቦች ይመልከቱ",
  十大品牌: "ምርጥ አስር ብራንዶች",
  查看所有品牌: "ሁሉንም የምርት ስሞች ይመልከቱ",
  登录: "ይግቡ",
  手机号码: "የስልክ ቁጥር",
  密码: "የይለፍ ቃል",
  密码长度为6到16个字符: "የይለፍ ቃል ርዝመት ከ 6 እስከ 16 ቁምፊዎች ነው",
  验证码: "የማረጋገጫ ኮድ",
  登录中: "ይግቡ",
  游客登录: "የቱሪስት መግቢያ",
  注册您的商店: "መደብርዎን ይመዝግቡ",
  现在申请: "አሁን ያመልክቱ",
  成为商家: "ነጋዴ ይሁኑ",
  现在注册: "አሁን ይመዝገቡ",
  登录成功: "ስኬታማ ግባ",
  通知: "ማሳወቅ",
  未找到通知: "ማሳወቂያ የለም",
  评论: "አስተያየት",
  估计运输时间: "የተገመተ መጓጓዣ ጊዜ",
  天: "ሰማይ",
  所售: "ሽያጭ",
  给商家留言: "መልእክት ወደ ነጋዴው ይተው",
  规格: "ዝርዝር መግለጫ",
  库存: "ለሽያጭ የቀረበ እቃ",
  总价: "አጠቃላይ ዋጋ",
  添加到购物车: "ወደ ጋሪ ያክሉ",
  立即购买: "አሁን ግዛ",
  缺货: "ከአክሲዮን ውጭ",
  添加到愿望清单: "ወደ ምኞት ዝርዝር ያክሉ",
  加入对比列表: "ንፅፅር ዝርዝር ያክሉ",
  退款: "ተመላሽ ገንዘብ",
  查看条款: "ሐረግ ይመልከቱ",
  分享: "አጋራ",
  描述: "ግለጽ",
  相关产品: "ተዛማጅ ምርቶች",
  没有人问过商家: "ነጋዴውን ማንም አልጠየቀም",
  该产品暂无评论: "በዚህ ምርት ላይ አስተያየት የለም",
  客户评论: "የደንበኛ አስተያየት",
  访问商店: "ሱቅ ይጎብኙ",
  畅销产品: "ምርጥ-ነክ ምርቶች",
  日期: "ቀን",
  订单编号: "የትእዛዝ ቁጥር",
  总额: "እብጠት ድምር",
  状态: "ግዛት",
  愿望清单: "የምኞት ዝርዝር",
  还没有添加任何东西: "እስካሁን ምንም ነገር አልጨመረም",
  注册: "ይመዝገቡ",
  邀请码: "የግብዣ ኮድ",
  请输入邀请码: "እባክዎ የግብዣው ኮድ ያስገቡ",
  用户名: "የተጠቃሚ ስም",
  请输入用户名: "እባክዎ የተጠቃሚውን ስም ያስገቡ",
  用户名长度为6_14个字符: "የተጠቃሚ ስም ርዝመት 6-14 ቁምፊዎች ነው",
  昵称: "ቅጽል ስም",
  请输入手机号码: "እባክዎ የሞባይል ስልክ ቁጥር ያስገቡ",
  手机号码格式错误: "የተንቀሳቃሽ ስልክ ቁጥር ቅርጸት ስህተት",
  密码长度为6_16个字符: "የይለፍ ቃል ርዝመት 6-16 ቁምፊዎች ነው",
  确认密码: "የይለፍ ቃል ያረጋግጡ",
  请输入确认密码: "እባክዎን የማረጋገጫውን የይለፍ ቃል ያስገቡ",
  提款密码: "የመልቀቂያ የይለፍ ቃል",
  请输入提款密码: "እባክዎን የማስወገጃውን የይለፍ ቃል ያስገቡ",
  提款密码长度为4_16个字符: "የማስወገጃው የይለፍ ቃል ርዝመት 4-16 ቁምፊዎች ነው",
  请输入验证码: "እባክዎ የማረጋገጫ ኮዱን ያስገቡ",
  在_s后发送: "{0} {0}}}",
  发送验证码: "የማረጋገጫ ኮዱን ይላኩ",
  注册即表示您同意我们的条款和条件: "ምዝገባ ማለት በእኛ ውሎች እና ሁኔታዎች ተስማምተዋል ማለት ነው.",
  创建账号: "መለያ ይፍጠሩ",
  验证码发送成功: "የማረጋገጫ ኮድ በተሳካ ሁኔታ ይልካል",
  确认密码不一致: "የይለፍ ቃሉ ወጥነት የጎደለው መሆኑን ያረጋግጡ",
  提款密码必须为数字: "የማስወገጃው ይለፍ ቃል መቁጠር አለበት",
  注册成功: "በተሳካ ሁኔታ ይመዝገቡ",
  购物车: "የግ Shopping ጋሪ",
  账户: "መለያ",
  我的账户: "የእኔ መለያ",
  已经有一个账户: "ቀድሞውኑ መለያ አለው",
  新地址: "አዲስ አድራሻ",
  编辑地址: "አርታኢ አድራሻ",
  保存: "አስቀምጥ",
  是否默认: "ወደ ነባሪው",
  具体地址: "ልዩ አድራሻ",
  请输入具体地址: "እባክዎን የተወሰነውን አድራሻ ያስገቡ",
  地区: "አካባቢ",
  请输入地区: "እባክዎ አካባቢውን ያስገቡ",
  城市: "ከተማ",
  请输入城市: "እባክዎን ከተማውን ያስገቡ",
  省份: "ክፍለ ሀገር",
  请输入省份: "እባክዎ ወደ ግዛቱ ያስገቡ",
  邮政编码: "የፖስታ መላኪያ ኮድ",
  请输入邮政编码: "እባክዎ የፖስታ ኮድ ያስገቡ",
  电话号码: "የስልክ ቁጥር",
  请输入电话号码: "እባክዎ የስልክ ቁጥሩን ያስገቡ",
  收货人: "ተያያዥነት",
  请输入收货人: "እባክዎ ተወካይ ያስገቡ",
  保存成功: "ስኬታማ ይሁኑ",
  最畅销的商家: "በጣም ጥሩው-ነክ ነጋዴ ነጋዴ",
  查看所有的商家: "ሁሉንም ነጋዴዎች ይፈትሹ",
  支持政策: "የድጋፍ ፖሊሲ",
  您的电子邮件地址: "የእርስዎ የኢሜል አድራሻ",
  订阅: "ምዝገባ",
  联系方式: "የእውቂያ መረጃ",
  地址: "አድራሻ",
  美国伊利诺伊州霍夫曼庄园: "የጉዞ ማንኪያ or ኦሎኖይ, ዩናይትድ ስቴትስ",
  快速链接: "ፈጣን አገናኝ",
  商家政策: "የነጋዴ ፖሊሲ",
  submit: "ያስገቡ",
  提款银行卡: "Adbb ካርድ",
  我的面板: "ፓነል",
  提示: "ፍንጭ",
  确定登出吗: "እርግጠኛ ነዎት እርስዎ ገብተዋል?",
  确定: "እርግጠኛ",
  取消: "ይቅር",
  项目添加到您的购物车: "ፕሮጀክቱ ወደ ግ shopping ጋሪዎ ታክሏል",
  经常一起购买: "ብዙ ጊዜ ይግዙ",
  返回购物: "ግብይት መመለሻ",
  进行结算: "ወደ ቼክ-ኣውት ቀጥል",
  帮助热线: "ሞቃት መስመርን ይረዱ",
  查看所有通知: "ሁሉንም ማሳወቂያዎች ይመልከቱ",
  请输入密码: "እባክዎ የይለፍ ቃሉን ያስገቡ",
  前往充值: "ለመሙላት ይሂዱ",
  购物车物品: "የግ Shopping ጋሪ",
  查看购物车: "የግብይት ጋሪውን ይፈትሹ",
  钱包余额: "የኪስ ቦርሳ ሚዛን",
  充值钱包: "ከረጢት",
  钱包充值_线下_: "የኪስ ቦርሳ መሙላት (ከመስመር ውጭ)",
  申请提款: "ለማለፍ ያመልክቱ",
  钱包收支明细: "የኪስ ቦርሳ ገቢ እና የወጪ ዝርዝሮች",
  批准: "ማጽደቅ",
  提现历史记录: "አመልካች ታሪካዊ መዝገብ",
  类型: "ዓይነት",
  信息: "መረጃ",
  付款方式: "የክፍያ ዘዴ",
  请选择付款方式: "የክፍያ ዘዴውን ይምረጡ",
  Bill_Type_RECHARGE_BACK: "ዳራ መሙላት",
  Bill_Type_RECHARGE_ONLINE: "የመስመር ላይ መሙላት",
  Bill_Type_RECHARGE_REGISTER: "ይመዝገቡ",
  Bill_Type_RECHARGE_JACKPOT: "መሙላት",
  Bill_Type_RECHARGE_PRESENT: "ሽልማት ያስገኛል",
  Bill_Type_RECHARGE_FROM_COMMISSION: "የኮሚሽኑ ማስተላለፍ",
  Bill_Type_RECHARGE_TG_COMMISSION: "የማስተዋወቂያ ኮሚሽን መሙላት",
  Bill_Type_REGISTER_TG_COMMISSION: "ይመዝገቡ እና ማስተዋወቂያ ኮሚሽን",
  Bill_Type_WITHDRAW: "መልቀቅ",
  Bill_Type_WITHDRAW_REJECT: "መልቀቅ",
  Bill_Type_DEDUCT_HANDLE: "ማኑዋሽን ቅናሽ",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "መሙላት",
  Bill_Type_MINING_PROFIT: "የማዕድን ገቢ",
  Bill_Type_MINING_PROFIT_COMMISSION: "የማዕድን ገቢ ማበረታቻ ኮሚሽን",
  Bill_Type_VIP_UPGRADE: "አሻሽል ቪአይፒ",
  Bill_Type_FINANCE_BUY: "የሀብት አስተዳደር የምርት ምርት ግ purchase",
  Bill_Type_FINANCE_CAPITAL_RETURN: "የፋይናንስ ሚዛን መመለስ",
  Bill_Type_FINANCE_FEE: "የገንዘብ አያያዝ ክፍያ",
  Bill_Type_FINANCE_PROFIT: "የገንዘብ ገቢ",
  Bill_Type_FINANCE_BUY_COMMISSION: "ለሀብት አስተዳደር ምርቶች የግ comment ኮሚሽኖች",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "የሀብት አያያዝ የምርት ገቢዎች የገቢ ኮሚሽን",
  Bill_Type_WHEEL_DRAW: "ትልልቅ ማቆሚያዎች",
  Bill_Type_BUY: "እቃዎችን ይግዙ",
  Bill_Type_PAY_SHOP: "የመላኪያ ክፍያ ይክፈሉ",
  Bill_Type_BUY_COMMISSION: "የሸቀጦች ኮሚሽን ይግዙ",
  Bill_Type_DEPOSIT: "ተቀማጭ ገንዘብ ይክፈሉ",
  Bill_Type_STORE_BUY: "እቃዎችን ይግዙ",
  Bill_Type_STORE_BUY_REFUND: "ተመላሽ ገንዘብ ይግዙ",
  Bill_Type: "የዕዳ ለውጥ ዓይነት",
  Before_Money: "ያለፈው መጠን",
  Deal_Money: "የመለያ ለውጥ መጠን",
  After_Money: "ቀጣይ መጠን",
  Bill_Time: "የሂሳብ ለውጥ",
  No_More_Data: "ተጨማሪ ውሂብ የለም",
  Apply_Money: "የትግበራ መጠን",
  Apply_Time: "የትግበራ ጊዜ",
  Withdraw_Info: "አያያዝ ክፍያ: - {ክፍያ}, ለሂሳብ: {ገንዘብ}",
  提款订单状态_CHECKING: "መገምገም",
  提款订单状态_TRANSFERRING: "ማስተላለፍ",
  提款订单状态_PASS: "አረጋግጥ",
  提款订单状态_REJECT: "ተቀባይነት አላገኘም",
  暂无可用充值方式: "ምንም ጠቃሚ የኃይል መሙያ ዘዴ የለም",
  钱包收款码: "የኪስ ቦርሳ አሰባሰብ ኮድ",
  钱包地址: "የኪስ ቦርሳ አድራሻ",
  金额限制: "የገደብ መጠን",
  复制: "ቅጂ",
  付款凭证: "የክፍያ ቫውቸር",
  收款银行: "ተቀባዩ ባንክ",
  收款人: "ገንዘብ ተቀባይ",
  收款账号: "ደረሰኝ መለያ",
  付款银行: "የክፍያ ባንክ",
  付款人: "ከፋይ",
  付款账号: "የክፍያ ሂሳብ",
  请输入付款银行: "እባክዎ የክፍያ ባንክ ያስገቡ",
  请输入付款人: "እባክዎ ከፋይዩ ያስገቡ",
  请输入付款账号: "እባክዎ የክፍያ ሂሳብ ያስገቡ",
  请上传付款凭证: "እባክዎ የክፍያ ቫውቸሮችን ይስቀሉ",
  充值金额: "የመሙላት መጠን",
  请输入充值金额: "እባክዎ የመሙላቱን መጠን ያስገቡ",
  submitting: "ገብቷል ...",
  Confirm: "ያስገቡ",
  Commit_Success: "ስኬታማ ማስገደድ",
  balanceType_BALANCE: "ሚዛን",
  balanceType_COMMISSION: "ኮሚሽኑ",
  Balance: "የሂሳብ ቀሪ ሂሳብ",
  Wash_Money: "ኮድ መስጠት",
  请选择银行账户: "እባክዎን የባንክ ሂሳብ ይምረጡ",
  卡号类型: "የካርድ ቁጥር",
  提现金额: "የማስወገድ መጠን",
  提款金额: "የማስወገድ መጠን",
  不能为空: "ባዶ ሊሆን አይችልም",
  金额不正确: "የተሳሳተ መጠን",
  please_input_withdraw_password: "እባክዎን የማስወገጃውን የይለፍ ቃል ያስገቡ",
  withdraw_password_format_error: "የማስወገጃው የይለፍ ቃል ከ4-16-ቢት ቁምፊዎች መሆን አለበት",
  Fee: "አያያዝ ክፍያ",
  实际到账: "በእውነቱ",
  交易币种: "የንግድ ምንዛሬ",
  原始密码: "የቀደመ የይለፍ ቃል",
  confirm_password_error: "በሁለት ግብዓቶች ውስጥ ያለው የይለፍ ቃል የተሳሳተ ነው",
  save_success: "ስኬታማ ይሁኑ",
  please_input: "እባክዎ ይግቡ",
  old_password: "የድሮ የይለፍ ቃል",
  new_password: "አዲስ የይለፍ ቃል",
  please_input_confirm_password: "እባክዎን የይለፍ ቃሉን እንደገና ያረጋግጡ",
  没有找到符合条件的商品: "ብቃት ያላቸው ምርቶችን ማግኘት አልተቻለም",
  Search: "ፍለጋ",
  全部: "ሁሉም",
  EnumGoodsOrderState_USER_PAY: "መሰራጨት",
  EnumGoodsOrderState_SHOP_PAY: "ስርጭት",
  EnumGoodsOrderState_SUCCESS: "ጨርስ",
  EnumGoodsOrderState_CANCEL: "ይቅር",
  EnumGoodsOrderState_REFUND_SUCCESS: "ተመላሽ ገንዘብ",
  订单号: "የትእዛዝ ቁጥር",
  用户名称: "የተጠቃሚ ስም",
  收益: "ገቢ",
  支付时间: "ክፍያ ይክፈሉ",
  配送时间: "የመላኪያ ጊዜ",
  完成时间: "የተሟላ ጊዜ",
  发货: "መርከብ",
  全选: "ሙሉ ምርጫ",
  物品已添加到愿望清单: "እቃዎቹ ወደ ምኞት ዝርዝር ውስጥ ታክለዋል",
  物品已添加到比较列表: "እቃዎቹ በንፅፅር ዝርዝር ውስጥ ታክለዋል",
  购买成功提示: "እንኳን ደስ አለዎት, በተሳካ ሁኔታ ይግዙ",
  订单列表: "የትዕዛዝ ዝርዝር",
  商品名: "የምርት ስም",
  图片: "ስዕል",
  没有品牌: "ምንም የምርት ስም የለም",
  基本信息: "መሰረታዊ መረጃ",
  Account_Name: "ስም",
  Bank_Account: "የባንክ ሂሳብ",
  Bank_Phone: "የተንቀሳቃሽ ስልክ ቁጥር",
  IFSC: "IFSC መለያ",
  UPI: "Ami መለያ",
  PIX: "የፒክስ መለያ ቁጥር",
  CPF: "CPF መለያ",
  GCASH: "Gcash መለያ",
  POWWI: "PoWWI መለያ",
  身份证号: "የመታወቂያ ቁጥር",
  Edit: "መከለስ",
  Delete: "ሰርዝ",
  Add: "ጨምር",
  Forget_Withdraw_Password: "በመልቀቅ ይለፍ ቃል ይረሱ",
  Bank_Card_Info: "የባንክ ካርድ መረጃ",
  收款人地址: "ገንዘብ ተቀባይ",
  SWIFT: "ፈጣን",
  Bank_Branch: "ንዑስ -BRANCH ስም",
  分行代码: "የቅርንጫፍ ሕግ",
  银行地址: "የባንክ አድራሻ",
  Email: "ኢሜል",
  银行卡长度必须超过: "የባንክ ካርዱ ርዝመት {ርዝመት መብለጥ አለበት}",
  银行卡格式不正确: "የባንክ ካርድ ቅርጸት የተሳሳተ ነው",
  Do_you_confirm_delete: "ሰርዝ አረጋግጠዋል?",
  Please_Login_First: "እባክዎ በመጀመሪያ ይግቡ",
  Bank_Name: "የባንክ ስም",
  Please_add_bank_first: "የባንክ ካርድ አላስገዙም, እባክዎን መጀመሪያ ያክሉ",
  withdrawType: "መውጣት",
  withdraw_money_limit: "የማስወገጃው መጠን ከ 0 እና ከ {ሂሳብ በታች ወይም እኩል መሆን አለበት",
  withdraw_times_limit: "ዛሬ {Nawithraddudume}}}}} {Destimes} ገንዘብ ለመውጣት ተወስኗል?",
  Copy_Success: "ማባዛት",
  商店首页: "የመነሻ ገጽን ያከማቹ",
  所有产品: "ሁሉም ምርቶች",
  新到货产品: "አዲስ - በአየር መንገድ ምርት",
  所有商家: "ሁሉም ነጋዴዎች",
  请上传: "እባክዎ ይስቀሉ",
  请输入: "እባክዎ ይግቡ",
  忘记密码: "የይለፍ ቃሉን ይረሱ",
  记得我: "አስታውሰኝ",
  共_件: "ጠቅላላ {0} ቁራጭ",
  取消订单: "ትዕዛዝ ይቅር",
  申请退款: "ተመላሽ ገንዘብ ያመልክቱ",
  未知商家: "ያልታወቀ ነጋዴ",
  到账: "መለያ",
  提款订单状态: "የማስወገጃ ስርዓት ሁኔታ",
  前_名类别: "የመጀመሪያ {0} ምድብ",
  取消订单原因_不想要了: "ከእንግዲህ አይፈልጉም",
  取消订单原因_商品错选_多选: "የምርት ስህተቶች / ብዙ ምርጫዎች",
  取消订单原因_商品无货: "- ከ -",
  取消订单原因_地址信息填写错误: "የአድራሻ መረጃ ስህተት ይሙሉ",
  取消订单原因_商品降价: "የሸቀጦች የዋጋ ቅናሽ",
  取消订单原因_价格高于其他平台: "ዋጋው ከሌሎች የመሣሪያ ስርዓቶች ከፍ ያለ ነው",
  取消订单原因_没用_少用_错用优惠: "ምንም / አነስተኛ / የስህተት ቅናሽ",
  退款原因_拍错_多拍_不喜欢: "የተሳሳቱ / ሾት የበለጠ / አይወዱትም",
  退款原因_商品成分描述不符: "የምርት አካል መግለጫ አይዛመድም",
  退款原因_与商家协商一致退款: "ከንግድ ተመላሽ ገንዘብ ጋር ማማከር",
  退款原因_生产日期_保质期与商品描述不符:
    "የምርት ቀን / የመደርደሪያ ህይወት ከምድር መግለጫ ጋር አይዛመድም",
  退款原因_图片_产地_批号_规格等描述不符:
    "የምስል / የመነሻ / የመነሻ / የመነሻ ቁጥር / ተቀጣጣይዎች, ወዘተ.",
  退款原因_质量问题: "ጥራት ያለው ጉዳይ",
  退款原因_商品变质_发霉_有异物: "የምርት ምርቶች / ሻጋታ / የውጭ አካል",
  退款原因_少件_含缺少配件_: "ትናንሽ ዕቃዎች (መለዋወጫዎችን ማጣት ጨምሮ)",
  退款原因_收到商品时有破损_污渍_变形: "ምርቱን ሲቀበሉ ጉዳቶች / ማቆሚያ / ጉድለት አለ",
  退款原因_假冒品牌: "ሐሰተኛ",
  退款原因_发票问题: "የክፍያ መጠየቂያ ችግር",
  退款原因_商家发错货: "ነጋዴዎች የተሳሳቱ እቃዎችን ይላኩ",
  退款原因_预约不到_商家不给退换: "ቀጠሮ / ነጋዴ ማድረግ አይቻልም",
  退款失败: "ተመላሽ ገንዘብ ውድቀት",
  退款处理中: "ተመላሽ ገንዘብ ማካሄድ",
  默认: "ነባሪ",
  产品查询: "የምርት መጠይቅ",
  商店LOGO: "የሱቅ አርማ ይግዙ",
  推广码: "የማስተዋወቂያ ኮድ",
  查看所有: "ሁሉንም ይፈትሹ",
  确认收货成功: "ደረሰኙ የተሳካ መሆኑን ያረጋግጡ",
  物流公司: "የሎጂስቲክስ ኩባንያ",
  物流单号: "የሎጂስቲክስ ትዕዛዝ ቁጥር",
  发货时间: "የመላኪያ ጊዜ",
  请先选择商品规格: "እባክዎ በመጀመሪያ የምርት መግለጫውን ይምረጡ",
  个人信息: "የግል መረጃ",
  您的用户名: "የተጠቃሚ ስምዎ",
  你的名字: "ስምህ",
  登录名: "የተጠቃሚ ስም",
  你的邮件: "የእርስዎ ደብዳቤ",
  你的密码: "የይለፍ ቃልዎ",
  重复输入密码: "የይለፍ ቃሉን ይድገሙ",
  店铺名称: "የሱቅ ስም",
  证书类型: "ዓይነት",
  身份证: "የመታወቂያ ካርድ",
  护照: "ፓስፖርት",
  驾驶执照: "የመንጃ ፈቃድ",
  社会保障卡: "የማህበራዊ ዋስትና ካርድ",
  证书正面: "አዎንታዊ የምስክር ወረቀት",
  证书反面: "ማረጋገጫ",
  确认收货: "የሸቀጦችን ደረሰኝ ያረጋግጡ",
  请选择取消订单的原因必选: "ትዕዛዙን ለመሰረዝ የሚያስችልበትን ምክንያት ይምረጡ (አስፈላጊ):",
  请选择申请退款的原因必选:
    "እባክዎን ተመላሽ ገንዘብ ለማመልከት የሚያስችልበትን ምክንያት ይምረጡ (ያስፈልጋል)",
  留言: "መልእክት",
  请输入留言: "እባክዎ መልእክት ያስገቡ",
  没有帐户: "ምንም መለያ የለም",
  钱包充值: "የኪስ ቦርሳ መሙላት",
  输入您的文字: "ጽሑፍዎን ያስገቡ",
  商家登录: "የነጋዴ መግቢያ",
  有关此产品的任何查询: "በዚህ ምርት ላይ ማንኛውም ጥያቄ",
  产品名称: "የምርት ስም",
  你的问题: "የእርስዎ ችግር",
  白银店铺: "ብር ሱቅ",
  铂金店铺: "የፕላቲኒየም ሱቅ",
  钻石店铺: "አልማዝ ሱቅ",
  照片: "ፎቶ",
  已退货: "ተመለሰ",
  邮寄状态: "የመልእክት ሁኔታ",
  订单摘要: "ትዕዛዝ ረቂቅ",
  收件地址: "የገቢ አድራሻ",
  订购日期: "የትዕዛዝ ቀን",
  订单状态: "የትዕዛዝ ሁኔታ",
  总订单金额: "ጠቅላላ የትእዛዝ መጠን",
  邮寄方式: "የመልእክት ዘዴ",
  附加信息: "ተጨማሪ መረጃ",
  订单详细信息: "ዝርዝር መረጃ",
  交货类型: "የአቅርቦት አይነት",
  进行评论: "አስተያየት",
  已评论: "አስተያየት ሰጥቷል",
  订单金额: "የትእዛዝ መጠን",
  优惠券: "ኩፖን",
  统一运费: "ያልተገለጸ የጭነት ጭነት",
  送货地址: "የመላኪያ አድራሻ",
  评分: "ውጤት",
  你的意见: "የእርስዎ አስተያየት",
  匿名: "ስም-አልባ",
  现金: "ጥሬ ገንዘብ",
  详情: "ዝርዝር",
  收货地址: "ደረሰኝ አድራሻ",
  暂时没有对话: "ለጊዜው ንግግር የለም",
  你: "አንተ",
  输入您的回复: "መልስዎን ያስገቡ",
  删除成功: "ሰርዝ",
  品牌: "የምርት ስም",
  已缴纳的保证金: "የተከፈለው ህዳግ",
  黄金店铺: "ወርቃማ ሱቅ",
  没有更多数据: "ተጨማሪ ውሂብ የለም",
  站内信: "በ-site ፊደል ላይ",
  系统通知: "የስርዓት ማስታወቂያ",
  邮箱: "ደብዳቤ",
  手机号: "የስልክ ቁጥር",
  你的手机号: "የሞባይል ስልክ ቁጥርዎ",
  营业执照: "የንግድ ፈቃድ",
  你的邮箱: "የእርስዎ የመልእክት ሳጥን",
  搜索结果: "የፍለጋ ውጤቶች",
  系统公告: "የስርዓት ማስታወቂያ",
  客服: "የደንበኞች አገልግሎት",
  消息已撤回: "ዜናው ተወግ has ል",
  物流详情: "የሎጂስቲክስ ዝርዝሮች",
  充值: "ከላይ",
  提现: "መልቀቅ",
  信用分: "ዱቤ",
  余额: "ሚዛን",
  佣金: "ኮሚሽኑ",
  继续购物: "ግብይት ቀጥል",
  订单结算: "ሰፈራ",
  加入对比: "ንፅፅር ያክሉ",
  佣金余额: "የኮሚሽኑ ሂሳብ",
  刷新: "አድስ",
  刷新成功: "አድስ",
  官网: "ኦፊሴላዊ ድር ጣቢያ",
  税号: "የግብር ቁጥር",
  订单: "ትዕዛዝ",
  合计: "ጠቅላላ",
  系统安全: "የስርዓት ደህንነት",
  Recharge_Money_Limit: "የመሙላቱ መጠን በ {ደቂቃ} መካከል መሆን አለበት እና {max}",
  限时优惠: "ውስን ጊዜ",
  高价回收: "ከፍተኛ-ተኮር እንደገና ጥቅም ላይ የዋለ",
  姓名: "ስም",
  商品订单号: "የሸቀጦች ትዕዛዝ ቁጥር",
  商品在线回收: "በመስመር ላይ በመስመር ላይ እንደገና ጥቅም ላይ የዋለው",
  提交: "ያስገቡ",
  回收记录: "የመልሶ ማግኛ መዝገብ",
  回收状态: "የመልሶ ማግኛ ሁኔታ",
  回收价格: "እንደገና ጥቅም ላይ የዋለው ዋጋ",
  纳税码: "የግብር ኮድ",
  买家登录: "ይግቡ",
  买家注册: "ይመዝገቡ",
  language: "ቻይንኛ",
  助力提示:
    "ነጋዴዎችን ማገዝ የመሣሪያ ስርዓቶችን መጋለጥ ለሱቆች ለመገጣጠም, እና ከፍተኛው ድምር, ከፍተኛ ተጋላጭነት ከፍተኛ ነው.",
  已累计助力: "በጣም የታገዘ",
  今日已助力: "ዛሬ ረድቷል",
  立即助力: "ወዲያውኑ እገዛ",
  商家助力: "የነጋዴ እገዛ",
  证件号码: "የመታወቂያ ቁጥር",
  证书号码: "የምስክር ወረቀት ቁጥር"
};
